import React from 'react';
export default function SquareFedora() {
  return (
<><ellipse cx="17.555" cy="6.013" rx="13.69" ry="4.33" transform="matrix(.99874 .05027 -.05558 .99845 0 0)" fill="#483737"/><path d="M10.173 1.904l-1.547 4.05s2.783 1.83 8.109 2.255c5.326.425 9.586-1.388 9.586-1.388l-1.168-4.656z" fill="#6c5353"/><ellipse transform="matrix(.9995 .03138 -.0889 .99604 0 0)" ry="1.489" rx="7.527" cy="1.465" cx="17.819" fill="#483737"/></>); }
